import { Initiator } from '../initiator';
import { RateItem } from '../rate';

export enum IntegrationName {
  Tehzor = 'tehzor',
}

export type Integration = {
  ext_id: string;
  name: IntegrationName;
};
export interface TicketsResponse {
  total?: number;
  tickets: TicketsResponseItem[];
}

export interface TicketsResponseItem {
  id: number;
  title: string;
  description: string;
  priority: string;
  status: string;
  class: string;
  sla: string;
  planned_start_at: string;
  planned_end_at: string;
  created_at: string;
  assignees: { id: number }[];
  types: any;
  objects: { id: number; type: string }[];
  origin: string;
  number: string;
  is_appeal: boolean;
  initiator: string | Initiator;
  actual_end_at: null | string;
  devices: { serialnumber: number }[];
  rate: null | RateItem;
  channel: { id: number; unread_messages: number };
  source?: {
    id: string;
    provider: {
      title: string;
      slug: string;
    };
  };
  support: {
    is_active: boolean;
  };
  updated_at: string;
  payment_status: {
    is_fully_paid: boolean;
    sum: number;
    title: string;
  };
  enterprise: Enterprise | null;
  enterprise_is: number | null;
  integrations: Integration[];
  related: RelatedApplication[];
}

export type RelatedApplication = {
  id: number;
  number: string;
};

export interface Enterprise {
  id: number;
  title: string;
}

export interface TicketsPayload {
  page?: number;
  per_page?: number;
  text?: string;
  created_at_from?: string;
  created_at_to?: string;
  statuses?: string[];
  is_support_active?: number;
  priorities?: string[];
  classes?: string[];
  types?: number[];
  paid?: boolean;
  invoice_status?: string;
  objects?: { id: number; type: string }[];
  stuff_write_off_needed?: number;
  assignees?: number[];
  rates?: string[];
  expired?: number;
  initiators?: number[];
  has_unread_messages?: number;
  integrations: IntegrationName[];
  using_favourite_filter?: boolean;
  has_related?: boolean;
}
